import { useMemo } from 'react'

import { QuizStatus, QuizzesResultsType } from 'app/types'
import { useQuery } from 'hooks'

export const QUIZ_ATTEMPTS_ENDPOINT = '/ca/v1/quiz-attempts'

export const useQuizStatuses = (playbookId: string, enabled = true) => {
    const shouldFetch = enabled && Boolean(playbookId)

    const { data, error } = useQuery<QuizzesResultsType>(
        shouldFetch ? `${QUIZ_ATTEMPTS_ENDPOINT}?playbookId=${playbookId}` : '',
        { method: 'GET' },
    )

    const statusByQuizId = useMemo(
        () =>
            Object.fromEntries((data?.quizzes ?? []).map(quiz => [quiz.quizId, quiz.status])) as Record<
                string,
                QuizStatus
            >,
        [data],
    )

    const isLoading = shouldFetch && !data && !error

    return { statusByQuizId, isLoading }
}
